import { EModel } from '@lumahealthhq/ui-model-types';

/**
 * Get the basePath for a model
 * @param {EModel} model - The model to get the basePath for
 * @returns {string} The basePath name
 */
export default function getModelBasePath(model) {
  switch (model) {
    case EModel.ChatActivityReason:
      return 'chatActivitiesReasons';
    case EModel.Diagnosis:
      return 'diagnoses';
    case EModel.BillingCopay:
      return 'billingCopays';
    default:
      {
        if (model.slice(-1) === 'y') {
          return model.replace(/.$/, 'ies');
        }
        return `${model}s`;
      }
  }
}